module.exports = __webpack_public_path__ + "static/media/responsibilities template.dcef36ce.xlsx";